import { getMentionSectionTitle } from '#pplx/frontend/components/form/lexical/plugins/mentionSectionTitle.js';
import { filterMentionTypeaheadOptions } from '#pplx/frontend/components/form/lexical/plugins/MentionsPluginSupport.js';
import { toMentionTypeaheadGroups } from '#pplx/frontend/composer-sdk-plugins/mention-typeahead/mentionTypeaheadGroups.js';
import { selectMentionTypeaheadOption } from '#pplx/frontend/composer-sdk-plugins/mention-typeahead/selectMentionTypeaheadOption.js';
/** @returns Providers in legacy section order, including empty sections for lazy option hydration. */
export function createMentionTypeaheadProviders({ $t, includeSlashProviders, mentionTypeaheadOptions, mentionTypeaheadContext: context, onTriggerTypeahead, spacesCopyVariant, }) {
    const sections = [
        {
            trigger: '@',
            variant: 'device',
            enabled: context?.devicesEnabled,
            options: context?.deviceOptions,
        },
        { trigger: '@', variant: 'sources', enabled: context?.includeSources },
        {
            trigger: '@',
            variant: 'space',
            enabled: context?.spacesEnabled,
            options: context?.spaceOptions,
        },
        { trigger: '@', variant: 'tab', enabled: context?.tabsEnabled, options: context?.tabOptions },
        {
            trigger: '/',
            variant: 'search-mode',
            enabled: context?.searchModesEnabled,
            options: context?.searchModeOptions,
        },
        {
            trigger: '/',
            variant: 'skills',
            enabled: context?.skillsEnabled,
            options: context?.skillOptions,
        },
        { trigger: '/', variant: 'shortcut' },
        { trigger: '/', variant: 'slash-command' },
        { trigger: '@', variant: 'user', enabled: context?.includeUsers },
    ];
    const providerFor = ({ trigger, variant, enabled, options = mentionTypeaheadOptions, }) => ({
        trigger,
        enabled,
        display: 'inline',
        section: {
            id: variant,
            title: getMentionSectionTitle({ $t, spacesCopyVariant, variant }),
        },
        emptyMessage: null,
        getResults: (query) => ({
            groups: toMentionTypeaheadGroups({
                options: filterMentionTypeaheadOptions({
                    options,
                    queryString: query,
                }).filter((option) => option.variant === variant),
            }),
        }),
        // Composer deduplicates trigger checks by callback identity across providers.
        onTrigger: onTriggerTypeahead,
        // Registration erases this provider's item subtype; every row carries the legacy option.
        onSelect: (item, editor) => selectMentionTypeaheadOption({ option: item.payload, editor }),
    });
    const [first, ...rest] = sections.filter(({ trigger }) => trigger !== '/' || (includeSlashProviders && context?.shouldUseComputerCommandMenu !== true));
    if (first === undefined)
        throw new Error('Mention typeahead requires at least one provider');
    return [providerFor(first), ...rest.map(providerFor)];
}
//# sourceMappingURL=createMentionTypeaheadProviders.js.map